import { apiFetch } from './client';

/** /support's form, to the Floto team. Answers with nothing on success. */
export function contactSupport(payload: {
  email: string;
  message: string;
  name: string;
}): Promise<void> {
  return apiFetch<void>('/support/contact', {
    body: JSON.stringify(payload),
    method: 'POST',
  });
}
